// Libellé public d'un type d'article. Source unique de vérité —
// à réutiliser plutôt que de redupliquer la map dans chaque écran.
const ARTICLE_TYPE_LABELS = {
    STAGE: "Retour d'expérience",
    PPE: "Projet encadré",
    PP: "Projet personnel",
    VEILLE_TECHNOLOGIQUE: "Veille technologique",
    VEILLE_JURIDIQUE: "Veille juridique",
    OTHER: "Article"
};

export const getArticleTypeLabel = (type) => ARTICLE_TYPE_LABELS[type] || "Article";

export default getArticleTypeLabel;
